@let breakpoints = this.breakpoints$ | async;
<ng-container>
  @if (breakpoints.isDesktop) {
    <aside class="sidebar" ppSidebar></aside>
  }

  <div class="container">
    <header class="header">
      <pp-header [breakpoints]="breakpoints" [data]="headerData()" />

      <pp-notifications [breakpoints]="breakpoints" />

      @if (!breakpoints.isDesktop) {
        <pp-menu />
      }
    </header>

    <main class="main">
      @if (!breakpoints.isDesktop) {
        <h1 class="title" [translate]="headerData().title"></h1>
      }
      <div class="main-content">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</ng-container>
